// extracted by mini-css-extract-plugin
module.exports = {"title":"TermsModal_title_LijdN","content":"TermsModal_content_noptH"};